// components/TextField.js
export default function TextField({ value, onChange, mode, config, ...props }) {
    if (mode === "view") return <span>{value}</span>;
    return <input 
        type="text" 
        value={value || ""} 
        onChange={e => onChange(e.target.value)} 
        className="form-control"
        {...props}
    />;
  }
  